(() => {
  if (customElements.get('inventa-product-gallery')) return;
  customElements.define('inventa-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this._galleryAbort) return;
      this._galleryAbort = new AbortController();
      const { signal } = this._galleryAbort;
      this._stage = this.querySelector('[data-gallery-stage]');
      this._thumbs = this.querySelector('[data-gallery-thumbs]');
      this._dialog = this.querySelector('[data-gallery-dialog]');
      if (!this._media) {
        this._media = new Map();
        this._baseIds = JSON.parse(this.dataset.galleryBaseIds || '[]').map(String);
        this._stage.querySelectorAll('[data-media-id]').forEach(slide => {
          const id = slide.dataset.mediaId;
          this._media.set(id, { slide, thumb: this._thumbs.querySelector('[data-gallery-thumb="' + id + '"]') });
        });
        this.querySelectorAll('[data-gallery-candidate]').forEach(template => {
          const slide = template.content.querySelector('[data-media-id]');
          const thumb = template.content.querySelector('[data-gallery-thumb]');
          if (slide && thumb) this._media.set(slide.dataset.mediaId, { slide, thumb });
          template.remove();
        });
      }
      document.forms[this.getAttribute('form')]?.addEventListener('variant:change', event => {
        this._selectVariant(event.detail?.variant?.featured_media?.id);
      }, { signal });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (thumb && this._thumbs.contains(thumb)) this._activate(thumb.dataset.galleryThumb);
        const zoom = event.target.closest('[data-zoom]');
        if (zoom && !zoom.closest('[data-media-id]').hidden) {
          const source = zoom.querySelector('img');
          const image = this._dialog.querySelector('[data-gallery-dialog-image]');
          image.src = source.currentSrc || source.src;
          image.alt = source.alt;
          if (!this._dialog.open) this._dialog.showModal();
        }
        if (event.target.closest('[data-gallery-close]')) this._dialog.close();
      }, { signal });
    }

    disconnectedCallback() {
      this._galleryAbort?.abort();
      this._galleryAbort = null;
      this._stage?.querySelectorAll('[data-media-id]').forEach(slide => this._pause(slide));
      if (this._dialog?.open) this._dialog.close();
    }

    _selectVariant(mediaId) {
      const id = String(mediaId || this.dataset.galleryFeaturedId);
      const selected = this._media.get(id);
      if (!selected) return;
      const ids = [...this._baseIds];
      if (!ids.includes(id)) {
        const match = ids.findIndex(baseId => this._media.get(baseId)?.slide.dataset.mediaKey === selected.slide.dataset.mediaKey);
        if (match !== -1) ids[match] = id;
        else if (ids.length < 5) ids.push(id);
        else ids[ids.length - 1] = id;
      }
      if (this._dialog.open) this._dialog.close();
      this._stage.querySelectorAll('[data-media-id]').forEach(slide => this._pause(slide));
      this._stage.replaceChildren(...ids.map(item => this._media.get(item).slide));
      this._thumbs.replaceChildren(...ids.map(item => this._media.get(item).thumb));
      this._thumbs.hidden = ids.length < 2;
      ids.forEach((item, index) => {
        this._media.get(item).thumb.setAttribute('aria-label', this.dataset.galleryItemLabel.replace('__INVENTA_INDEX__', String(index + 1)));
      });
      this._activate(id);
    }

    _activate(id) {
      this._stage.querySelectorAll('[data-media-id]').forEach(slide => {
        const hidden = slide.dataset.mediaId !== id;
        if (hidden && !slide.hidden) this._pause(slide);
        slide.hidden = hidden;
      });
      this._thumbs.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        thumb.setAttribute('aria-current', String(thumb.dataset.galleryThumb === id));
      });
    }

    _pause(slide) {
      slide.querySelectorAll('video, model-viewer').forEach(media => media.pause?.());
      slide.querySelectorAll('iframe').forEach(frame => {
        if (slide.hidden) return;
        frame.src = frame.src;
      });
    }
  });
})();

(() => {
  if (customElements.get('inventa-product-chargers')) return;
  customElements.define('inventa-product-chargers', class extends HTMLElement {
    connectedCallback() {
      if (this._chargerAbort) return;
      this._chargerAbort = new AbortController();
      const { signal } = this._chargerAbort;
      const update = image => {
        image.hidden = !image.complete || image.naturalWidth === 0;
        this.hidden = !this.querySelector('img:not([hidden])');
      };
      this.querySelectorAll('img').forEach(image => {
        image.addEventListener('load', () => update(image), { signal });
        image.addEventListener('error', () => {
          image.hidden = true;
          this.hidden = !this.querySelector('img:not([hidden])');
        }, { signal });
        update(image);
      });
    }

    disconnectedCallback() {
      this._chargerAbort?.abort();
      this._chargerAbort = null;
    }
  });
})();
